const cleanLocalStorage = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('selected_room');
};

export default cleanLocalStorage;
